interface IAuthUser {
  name?: string;
  userId?: string;
}

const getAuthUser = (state: any): IAuthUser => state?.authReducer;

export default getAuthUser;